export const addDistanceToCoordinate = (coordinate: number, distance: number) =>
  coordinate + (180 / Math.PI) * (distance / 6378137);
